export const ApplicationName = {
	core: 'core',
	quickAccess: 'quickAccess',
	messenger: 'messenger'
};

export const ApplicationLayout = {
	lines: 'lines',
	full: 'full',
};